const Promise = require('bluebird')
const Mousetrap = require('mousetrap')
const moment = require('moment')
const $ = require('jquery')

const utils = (self = $(document)) => new Promise((resolve, reject) => {
    $(document).on('mouseenter', '.bs-tooltip', function () {
        $(this).tooltip('show')
    })

    $(document).on('click', '.ignore-this-dropdown', function (evt) {
        evt.preventDefault()
        return false
    })

    Mousetrap.bind('/', function (e) {
        $('#full-global-search').addClass('visible').show()
        $('#full-global-search').find('.pipeline-search').focus()
        $('#full-global-search').find('.pipeline-search').on('search:blur', function () {
            $('#full-global-search').removeClass('visible').hide()
        })
        $('#full-global-search').find('.modal-backdrop').on('click', function () {
            $('#full-global-search').removeClass('visible').hide()
        })
        return false
    })

    if (!$(self).data('download-runtime-info')) {
        $(self).on('click', '.download-runtime-info', function (e) {
            const sci = document.SCI_DATA || {}
            const name = 'sci-info.json'
            const date = moment()
            const connection = {};

            if (navigator.connection) {
                connection.downlink = navigator.connection.downlink
                connection.effectiveType = navigator.connection.effectiveType
                connection.rtt = navigator.connection.rtt
            }

            const data = {
                online: navigator.onLine,
                instance: sci.instance,
                user: sci.user,
                token: sci.token,
                url: location.href,
                date: {
                    date: date.format('YYYY-MM-DD HH:mm:ss'),
                    offset: date.utcOffset()
                },
                connection,
                adblockEnabled: window.__userIsUsingAdblockOrRelated,
                navigator: {
                    deviceMemory: navigator.deviceMemory,
                    appCodeName: navigator.appCodeName,
                    appName: navigator.appName,
                    appVersion: navigator.appVersion,
                    cookieEnabled: navigator.cookieEnabled,
                    hardwareConcurrency: navigator.hardwareConcurrency,
                    language: navigator.language,
                    languages: navigator.languages,
                    platform: navigator.platform,
                    product: navigator.product,
                    productSub: navigator.productSub,
                    userAgent: navigator.userAgent,
                    vendor: navigator.vendor,
                    vendorSub: navigator.vendorSub
                },
                session_data: sci.session_data,
                build_name: window.__name,
                build_slug_name: window.__slugname,
                errors: window.__rescueErrors,
                log: window.__rescueLogs
            }

            const type = 'data:application/json'

            const dataString = JSON.stringify(data)

            if (dataString != null && navigator.msSaveBlob) {
                return navigator.msSaveBlob(new Blob([dataString], { type: type }), name)
            }
            var a = $('<a style="display: none;"/>')
            var url = window.URL.createObjectURL(new Blob([dataString], { type: type }))
            a.attr('href', url)
            a.attr('download', name)
            $('body').append(a)
            a[0].click()
            window.URL.revokeObjectURL(url)
            a.remove()
        })

        $(self).data('download-runtime-info', true)
    }

    const showInfo = function (e) {
        const version = $('#app-version')

        if (version.hasClass('visible')) {
            version.removeClass('visible')
        } else {
            version.addClass('visible')
        }

        const lastErrors = version.find('.last-errors')

        lastErrors.text(JSON.stringify(window.__rescueErrors))

        return false
    }

    Mousetrap.bind('?', showInfo)
    Mousetrap.bind('ctrl+/', showInfo)

    resolve()
})

module.exports = utils



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/ui/utils.js